import React, { useEffect, useRef, useState } from 'react';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import '@syncfusion/ej2-react-popups/styles/material.css';
import YouTube from 'react-youtube';
import LoadingNew from '../layouts/loadingnew';
import { VideoTutorialsGetAllParams } from '@/lib/actions/shared.types';

interface TutorialDialogProps {
    visible: boolean;
    tutorial: VideoTutorialsGetAllParams | null;
    onClose: () => void;
}

const TutorialDialog: React.FC<TutorialDialogProps> = ({ visible, tutorial, onClose }) => {
    const [iframeSrc, setIframeSrc] = useState(`${tutorial?.url}`);
    const vdoDialogRef = useRef<DialogComponent>(null);

    const [isProcessing, setIsProcessing] = useState(true);
    const [hasLoaded, setHasLoaded] = useState(false);

    const opt = {
        height: '390',
        width: '640',
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: 1,
        },
    };

    useEffect(() => {
        if (visible) {
            setIsProcessing(true);
            // Set the iframe source when the dialog becomes visible
            setIframeSrc(`${tutorial?.url}`);
        } else {
            // Clear the iframe source when the dialog is hidden
            // console.log('clearing iframe');
            setIframeSrc('');

            setIsProcessing(false);
            setHasLoaded(false);
        }
    }, [visible]);

    useEffect(() => {
        // Ensure the dialog is properly destroyed when the component unmounts
        return () => {
            if (vdoDialogRef.current) {
                vdoDialogRef.current.destroy();
            }
        };
    }, []);

    return (
        <DialogComponent
            id="vdodialog"
            width={'90%'}
            height={'95%'}
            // height="auto"
            visible={visible}
            showCloseIcon={true}
            closeOnEscape
            header={tutorial?.name}
            footerTemplate={null}
            isModal={true}
            allowDragging={true}
            // allowDragging={true} This takes dialog to the extream right
            // enableResize={true}
            // target=".control-section"
            ref={vdoDialogRef}
            zIndex={10035}
            close={onClose}
            className="px-1 pb-1 pt-0"
        >
            <div className="flex size-full">
                {isProcessing && (
                    <div className="absolute inset-0 z-10 flex items-center justify-center">
                        <LoadingNew />
                    </div>
                )}
                {/* {iframeSrc && (
                    <iframe
                        src={iframeSrc}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className={`youtube-container m-0 size-full p-0 ${hasLoaded ? 'block' : 'hidden'}`}
                        style={{ margin: 0, padding: 0, border: 0 }} // Remove unnecessary spacing
                        tabIndex={-1}
                    />
                )} */}
                {iframeSrc && (
                    <YouTube
                        key={tutorial?.vid}
                        videoId={tutorial?.vid}
                        opts={opt}
                        onReady={() => {
                            // console.log('ready');
                            setIsProcessing(false);
                            setHasLoaded(true);
                        }}
                        className={`youtube-container size-full ${hasLoaded ? 'block' : 'hidden'}`}
                    />
                )}
            </div>
        </DialogComponent>
    );
};

export default TutorialDialog;
